import React, { useEffect, useState } from 'react';

interface EmailVerificationScreenProps {
  token: string;
  onVerificationSuccess: (userData: any) => void;
}

const EmailVerificationScreen: React.FC<EmailVerificationScreenProps> = ({
  token,
  onVerificationSuccess
}) => {
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('メールアドレスを認証中...');

  useEffect(() => {
    let isMounted = true; // コンポーネントのマウント状態を追跡

    const verifyEmail = async () => {
      try {
        const API_URL = 'https://voicechatapi.kasaneko.com';
        
        // メールアドレス認証
        const response = await fetch(`${API_URL}/api/email-verification/verify/${token}`);
        const data = await response.json();

        if (!isMounted) {
          return; // アンマウント済みなら処理を中止
        }

        if (data.success && data.userData) {
          setStatus('success');
          setMessage('メールアドレス認証完了！ユーザー登録中...');
          
          // 本登録処理を実行
          try {
            const registerResponse = await fetch(`${API_URL}/api/auth/complete-registration`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data.userData)
            });

            const registerData = await registerResponse.json();

            if (!isMounted) {
              return; // アンマウント済みなら処理を中止
            }

            if (registerData.success && registerData.token && registerData.user) {
              setMessage('登録完了！ログインしています...');
              
              // 即座にログイン処理へ（遅延なし）
              localStorage.setItem('token', registerData.token);
              localStorage.setItem('user', JSON.stringify(registerData.user));
              
              // 少しだけ待ってから遷移（メッセージを読む時間）
              setTimeout(() => {
                if (isMounted) {
                  onVerificationSuccess(registerData.user);
                }
              }, 1000);
            } else {
              setStatus('error');
              setMessage(registerData.error || '登録処理に失敗しました');
            }
          } catch (registerError) {
            console.error('登録処理エラー:', registerError);
            if (isMounted) {
              setStatus('error');
              setMessage('登録処理中にエラーが発生しました');
            }
          }
        } else {
          setStatus('error');
          setMessage(data.error || '認証に失敗しました');
        }
      } catch (error) {
        console.error('認証エラー:', error);
        if (isMounted) {
          setStatus('error');
          setMessage('認証中にエラーが発生しました');
        }
      }
    };
    
    verifyEmail();

    // クリーンアップ関数
    return () => {
      isMounted = false;
    };
  }, [token, onVerificationSuccess]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #dcdcdc 100%)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Arial, sans-serif',
      color: 'white'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        padding: '60px 40px',
        borderRadius: '20px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
        maxWidth: '500px'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>
              ⏳
            </div>
            <h2 style={{ margin: '0 0 20px 0', fontSize: '28px' }}>
              認証中...
            </h2>
            <p style={{ fontSize: '16px', opacity: 0.9 }}>
              {message}
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>
              ✅
            </div>
            <h2 style={{ margin: '0 0 20px 0', fontSize: '28px' }}>
              認証完了！
            </h2>
            <p style={{ fontSize: '16px', opacity: 0.9 }}>
              {message}
            </p>
            <p style={{ fontSize: '14px', opacity: 0.7, marginTop: '20px' }}>
              自動的にユーザー登録を完了します...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>
              ❌
            </div>
            <h2 style={{ margin: '0 0 20px 0', fontSize: '28px' }}>
              認証失敗
            </h2>
            <p style={{ fontSize: '16px', opacity: 0.9, marginBottom: '30px' }}>
              {message}
            </p>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: '#667eea',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              トップに戻る
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationScreen;

